import axios from 'axios'
import { configApi, requester, configApiForm } from '../..'
import { ACCOUNT } from '../../../domain/constants'
import {
  IAccountInfo,
  IChangePasswordRequest,
  IFLogin,
  IFRegister,
  IGoogleLoginRequest,
  IResetPasswordRequest,
  IAdminCreateAccountRequest,
  IGetAccountsRequest,
  IPagingResult
} from '../../../domain/interfaces/IAccount'
import { IAuthenticationTokenResult } from '@src/domain/interfaces/IAuthenticationTokenResult'

const { URL_API } = ACCOUNT

const accountApi = {
  registerApi: (params: IFRegister) => requester.post(`${URL_API.REGISTER_API}`, params, configApi()),
  loginApi: (params: IFLogin) => requester.post(URL_API.LOGIN_API, params, configApi()),
  loginWithGoogle: (params: IGoogleLoginRequest) => requester.post(URL_API.LOGIN_GOOGLE_API, params),
  changePasswordApi: (params: IChangePasswordRequest) =>
    requester.post(URL_API.CHANGE_PASSWORD_API, params, configApi()),
  resetPasswordApi: (params: IResetPasswordRequest) => requester.post(URL_API.RESET_PASSWORD_API, params, configApi()),
  logoutApi: () => requester.post(URL_API.LOGOUT_API, {}, configApi()),
  verifyEmailApi: (params: { email: string; verifyCode: string }) => requester.post(URL_API.VERIFY_EMAIL_API, params),
  resendVerifyCodeApi: (email: string) => requester.post(URL_API.RESEND_VERIFY_CODE_API, { email }),
  forgotPasswordApi: (params: { email: string }) => requester.post(URL_API.FORGOT_PASSWORD_API, params),
  resetPasswordWithCodeApi: (params: { email: string; resetCode: string; newPassword: string }) =>
    requester.post(URL_API.RESET_PASSWORD_WITH_CODE_API, params),
  createAccountApi: (params: IAdminCreateAccountRequest) =>
    requester.post(URL_API.CREATE_ACCOUNT_API, params, configApi()),
  updateAccountApi: (params: any) => requester.post(URL_API.UPDATE_ACCOUNT_API, params, configApi()),
  getAccountsApi: (params: IGetAccountsRequest): Promise<IPagingResult<IAccountInfo>> =>
    requester.get(URL_API.GET_ACCOUNTS_API, params, configApi()),
  toggleAccountStatusApi: (accountId: string) =>
    requester.post(`${URL_API.TOGGLE_ACCOUNT_STATUS_API}/${accountId}`, {}, configApi()),
  getAccountInfoApi: (): Promise<IAccountInfo> => requester.get(ACCOUNT.URL_API.GET_ACCOUNT_INFO_API, {}, configApi()),
  approveUserProfileApi: (userId: string, isApprove = true, note?: string) =>
    requester.post(`${URL_API.APPROVE_PROFILE_API}/${userId}?isApprove=${isApprove}${note ? `&note=${encodeURIComponent(note)}` : ''}`, {}, configApi()),
  requestUserProfileUpdateApi: (userId: string, params: { requiredFields: string[]; note: string }) =>
    requester.post(`${URL_API.REQUEST_PROFILE_UPDATE_API}/${userId}`, params, configApi()),
  updateBankApi: (params: FormData) => requester.post(URL_API.UPDATE_BANK_API, params, configApiForm())
}

export const refreshTokenApi = ({ refreshToken }: { refreshToken: string }) => {
  const endpoint = URL_API.REFETCH_TOKEN_API

  if (!endpoint || endpoint.includes('undefined')) {
    return Promise.reject(new Error('Refresh token endpoint is not configured'))
  }

  return axios
    .post<IAuthenticationTokenResult>(
      endpoint,
      { refreshToken },
      {
        headers: {
          'Content-Type': 'application/json',
          'x-skip-auth-refresh': 'true'
        }
      }
    )
    .then(res => res.data)
}

export default accountApi

export const getAccountInfoApi = (): Promise<IAccountInfo> => {
  return requester.get(ACCOUNT.URL_API.GET_ACCOUNT_INFO_API, {}, configApi())
}
